import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import cx from 'classnames';
import css from './Faq.scss';

export class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClick(index) {
    this.setState(prevState => ({
      [`q${index}`]: !prevState[`q${index}`],
    }));
  }

  render() {
    const { title, faq, backgroundColor } = this.props;

    return (
      <div className={`bg--${backgroundColor || 'white'}`}>
        <div className={css.base}>
          <h2 className="gamma">{title}</h2>
          <ul>
            {faq.map((q, i) => (
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
              <li
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                onClick={() => this.handleClick(i, q.question)}>
                <h3>
                  <Isvg
                    className={cx(css.arrow, {
                      [css.selected]: this.state[`q${i}`] || false,
                    })}
                    uniquifyIDs={false}
                    src={require('static/img/arrow.svg')}
                  />
                  {q.question}
                </h3>
                {!!this.state[`q${i}`] && <p>{q.answer}</p>}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

Faq.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'light']),
  faq: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      question: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  title: PropTypes.string,
};

Faq.propMapper = (state, moduleDef) => ({
  title: moduleDef.title,
  faq: moduleDef.questions,
});
